/* ============================================================
   Fixtore Plan Renove / Trade-In · assets/fx-trade-in.js
   Sistema cliente: catálogo, tasación, modal, validaciones,
   payload preparado, cart attributes informativos.
   No aplica descuentos reales. No expone IMEI en cart.
   ============================================================ */
(function () {
  'use strict';

  // ----- CONFIG GLOBAL (sobrescribible desde theme.liquid) -----
  var CONFIG = (window.FIXTORE_TRADE_IN_CONFIG = window.FIXTORE_TRADE_IN_CONFIG || {
    webhookUrl: '',
    enableWebhook: false,
    storeName: 'Fixtore',
    storeCity: 'Gandía',
    devicesUrl: '',    // se inyecta desde Liquid con asset_url
    rulesUrl: '',
    debug: false
  });

  function log() { if (CONFIG.debug && console && console.log) console.log.apply(console, ['[FXTI]'].concat([].slice.call(arguments))); }

  // ----- ESTADO -----
  var DEVICES = null;
  var RULES = null;
  var state = freshState();
  var modalEl = null;
  var blockTriggers = [];

  function freshState() {
    return {
      step: 0,
      modelId: null,
      modelMeta: null,    // { brand, model, year, rules_profile, capacities }
      capacity: null,
      mode: '',              // 'tasar' | 'renew'
      orderNumber: '',
      refundChoice: '',      // 'refund' | 'credit'
      answers: {},        // { power: 'ok', screen: 'minor', ... }
      battery: null,
      imei: '',
      customer: { name: '', email: '', phone: '', postal_code: '' },
      method: '',         // 'store' | 'ship'
      legal: { provisional_valuation: false, return_shipping_cost: false, privacy: false },
      result: null,       // { value, grade, confidence, flags, blocked, manualReview }
      quoteId: null,
      originProduct: window.FXTI_ORIGIN_PRODUCT || null
    };
  }

  // ----- CARGA JSON -----
  function loadJSON(url) {
    return fetch(url, { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error('fetch ' + r.status); return r.json(); });
  }

  function init() {
    if (!CONFIG.devicesUrl || !CONFIG.rulesUrl) { log('no urls'); return; }
    Promise.all([loadJSON(CONFIG.devicesUrl), loadJSON(CONFIG.rulesUrl)])
      .then(function (res) {
        DEVICES = res[0]; RULES = res[1];
        log('data loaded', DEVICES._meta, RULES._meta);
        wireUp();
      })
      .catch(function (e) {
        log('data load failed', e);
        // fail-safe: deshabilitar botones
        document.querySelectorAll('[data-fxti-open]').forEach(function (b) {
          b.disabled = true;
          b.setAttribute('aria-disabled', 'true');
          b.style.opacity = '.55';
          b.title = 'Plan Renove temporalmente no disponible';
        });
      });
  }

  function wireUp() {
    blockTriggers = [].slice.call(document.querySelectorAll('[data-fxti-open]'));
    blockTriggers.forEach(function (btn) {
      btn.addEventListener('click', openModal);
    });
    modalEl = document.querySelector('[data-fxti-modal]');
    if (!modalEl) return;
    modalEl.querySelectorAll('[data-fxti-close]').forEach(function (b) {
      b.addEventListener('click', closeModal);
    });
    var bd = modalEl.querySelector('.fxti-modal__backdrop');
    if (bd) bd.addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modalEl.classList.contains('is-open')) closeModal();
    });
    renderStep(0);
  }

  // ----- MODAL -----
  function openModal() {
    if (!modalEl) return;
    state = freshState();
    buildSteps();
    renderStep(0);
    modalEl.classList.add('is-open');
    document.body.classList.add('fxti-modal-open');
    hideFixedBottomBars();
    var first = modalEl.querySelector('input, button, [tabindex]');
    if (first) setTimeout(function () { first.focus(); }, 50);
  }
  function closeModal() {
    if (!modalEl) return;
    modalEl.classList.remove('is-open');
    document.body.classList.remove('fxti-modal-open');
    restoreFixedBottomBars();
  }
  function hideFixedBottomBars() {
    try {
      var all = document.querySelectorAll('body *');
      var viewH = window.innerHeight;
      modalEl._fxtiHidden = [];
      for (var i = 0; i < all.length; i++) {
        var el = all[i];
        if (el === modalEl || modalEl.contains(el) || el.contains(modalEl)) continue;
        var s = window.getComputedStyle(el);
        if (s.position !== 'fixed' && s.position !== 'sticky') continue;
        var rect = el.getBoundingClientRect();
        // Barras inferiores típicas: están en el 35% inferior y son cortas
        if (rect.top > viewH * 0.55 && rect.height < 260 && rect.width > 100) {
          modalEl._fxtiHidden.push({ el: el, d: el.style.display });
          el.setAttribute('data-fxti-hidden-by-modal', '1');
          el.style.setProperty('display', 'none', 'important');
        }
      }
    } catch (e) { log('hide fixed bars failed', e); }
  }
  function restoreFixedBottomBars() {
    if (!modalEl || !modalEl._fxtiHidden) return;
    modalEl._fxtiHidden.forEach(function (it) {
      it.el.style.display = it.d || '';
      it.el.removeAttribute('data-fxti-hidden-by-modal');
    });
    modalEl._fxtiHidden = null;
  }

  // ----- STEPS DEFINICIÓN -----
  // Cada step retorna HTML + validación local
  var STEPS = [];
  function buildSteps(){
    var s = [{ id: 'mode', title: 'Plan Renove', sub: '¿Qué quieres hacer?' }];
    if (state.mode === 'renew') s.push({ id: 'order', title: 'Tu número de pedido', sub: 'El de la compra del iPhone' });
    s.push({ id: 'model', title: 'Elige tu dispositivo', sub: 'Selecciona modelo y capacidad' });
    s.push({ id: 'power', question: 'power' });
    s.push({ id: 'screen', question: 'screen' });
    s.push({ id: 'frame', question: 'frame' });
    s.push({ id: 'battery', title: 'Salud de batería', sub: 'Ajustes → Batería → Estado de la batería' });
    s.push({ id: 'faceid', question: 'faceid' });
    s.push({ id: 'camera', question: 'camera' });
    s.push({ id: 'charging', question: 'charging' });
    s.push({ id: 'buttons_audio', question: 'buttons_audio' });
    s.push({ id: 'parts', question: 'parts' });
    s.push({ id: 'icloud', question: 'icloud' });
    s.push({ id: 'imei', title: 'IMEI o número de serie', sub: 'Recomendado · marca *#06# en tu teléfono' });
    s.push({ id: 'customer', title: 'Tus datos de contacto', sub: 'Para enviarte la valoración' });
    if (state.mode === 'renew') {
      s.push({ id: 'method', title: '¿Cómo entregas el móvil?', sub: 'Selecciona una opción' });
      s.push({ id: 'refund', title: '¿Cómo quieres el reintegro?', sub: 'Elige tu preferencia' });
      s.push({ id: 'legal', title: 'Confirmación', sub: 'Revisa y acepta las condiciones' });
    }
    s.push({ id: 'result', title: 'Tu valoración aproximada' });
    STEPS = s;
  }

  function renderStep(idx) {
    state.step = idx;
    var bodyEl = modalEl.querySelector('[data-fxti-body]');
    var progressEl = modalEl.querySelector('[data-fxti-progress]');
    var counterEl = modalEl.querySelector('[data-fxti-counter]');
    var step = STEPS[idx];
    if (!step) return;

    if (progressEl) progressEl.style.width = (((idx + 1) / STEPS.length) * 100) + '%';
    if (counterEl) counterEl.textContent = 'Paso ' + (idx + 1) + ' de ' + STEPS.length;

    var html = '';
    if (step.id === 'mode')        html = renderModeStep();
    else if (step.id === 'order')  html = renderOrderStep();
    else if (step.id === 'refund') html = renderRefundStep();
    else if (step.id === 'model')  html = renderModelStep();
    else if (step.id === 'battery')html = renderBatteryStep();
    else if (step.id === 'imei')   html = renderImeiStep();
    else if (step.id === 'customer') html = renderCustomerStep();
    else if (step.id === 'method') html = renderMethodStep();
    else if (step.id === 'legal')  html = renderLegalStep();
    else if (step.id === 'result') html = renderResultStep();
    else if (step.question)        html = renderQuestionStep(step.question);
    bodyEl.innerHTML = '<div class="fxti-step is-on">' + html + '</div>';

    renderFooter(idx);
    wireStep(step);
  }

  // ----- RENDERS -----
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]); }); }

  function renderModeStep(){
    return '<p class="fxti-step__legend">Plan Renove</p>' +
      '<h2 class="fxti-step__title">¿Qué quieres hacer?</h2>' +
      '<p class="fxti-step__sub">Tasa tu iPhone en 1 minuto. El reintegro es posterior: primero compras tu nuevo iPhone y, tras revisar tu antiguo, te devolvemos su valor.</p>' +
      '<div class="fxti-options">' +
      '<div class="fxti-opt" data-fxti-mode="tasar" tabindex="0" role="button"><span class="fxti-opt__r"></span><span class="fxti-opt__tx">Solo quiero tasar mi iPhone<small>Mira cuánto vale y decide. Sin compromiso ni compra.</small></span></div>' +
      '<div class="fxti-opt" data-fxti-mode="renew" tabindex="0" role="button"><span class="fxti-opt__r"></span><span class="fxti-opt__tx">Ya compré un iPhone y quiero renovar<small>Tasamos tu antiguo y te reintegramos su valor.</small></span></div>' +
      '</div>';
  }

  function renderOrderStep(){
    return '<p class="fxti-step__legend">Verificación de compra</p>' +
      '<h2 class="fxti-step__title">Tu número de pedido</h2>' +
      '<p class="fxti-step__sub">Introduce el número del pedido de tu iPhone en Fixtore (está en el email de confirmación, ej. #1234). Verificaremos que existe y está pagado.</p>' +
      '<div class="fxti-field" data-fxti-field="order"><label for="fxti-order">Número de pedido<span class="req">*</span></label>' +
      '<input id="fxti-order" type="text" autocomplete="off" value="' + esc(state.orderNumber || '') + '" data-fxti-order placeholder="#1234"><p class="fxti-field__err">Introduce tu número de pedido</p></div>' +
      '<p class="fxti-field__hint">El reintegro se aplicará sobre este pedido tras la tasación final.</p>';
  }

  function renderRefundStep(){
    var sel = state.refundChoice;
    return '<p class="fxti-step__legend">Reintegro</p>' +
      '<h2 class="fxti-step__title">¿Cómo quieres recibir el valor?</h2>' +
      '<p class="fxti-step__sub">Lo recibirás tras la tasación final (máx. 72 h desde que recibamos tu móvil) y tu visto bueno.</p>' +
      '<div class="fxti-options">' +
      '<div class="fxti-opt' + (sel==='refund'?' is-active':'') + '" data-fxti-refund="refund" tabindex="0" role="button"><span class="fxti-opt__r"></span><span class="fxti-opt__tx">Reembolso parcial<small>Te devolvemos el valor tasado sobre tu pedido.</small></span></div>' +
      '<div class="fxti-opt' + (sel==='credit'?' is-active':'') + '" data-fxti-refund="credit" tabindex="0" role="button"><span class="fxti-opt__r"></span><span class="fxti-opt__tx">Saldo Fixtore o tarjeta regalo · +10% extra<small>Recibe la tasación +10% para gastar en Fixtore.</small></span></div>' +
      '</div>';
  }

  function renderModelStep() {
    var brand = DEVICES.brands[0]; // Apple por ahora
    var models = brand.models;
    // Si ya hay modelo seleccionado: card destacada + capacidad grande
    if (state.modelMeta) {
      var m = state.modelMeta;
      var caps = Object.keys(m.capacities);
      var capsHtml = caps.map(function (cap) {
        var a = (state.capacity === cap) ? ' is-active' : '';
        return '<button type="button" class="fxti-cap-card' + a + '" data-fxti-cap="' + esc(cap) + '">' + esc(cap) + '</button>';
      }).join('');
      return '<p class="fxti-step__legend">Modelo seleccionado</p>' +
        '<div class="fxti-selected-card">' +
        '<div class="fxti-selected-card__check"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></div>' +
        '<div class="fxti-selected-card__tx"><span class="fxti-selected-card__name">' + esc(m.model) + '</span><span class="fxti-selected-card__year">' + m.year + '</span></div>' +
        '<button type="button" class="fxti-change-link" data-fxti-change-model>Cambiar</button>' +
        '</div>' +
        '<p class="fxti-step__legend" style="margin-top:14px">Capacidad de almacenamiento</p>' +
        '<div class="fxti-caps-grid">' + capsHtml + '</div>';
    }
    // Sin selección: lista agrupada por año
    var byYear = {};
    models.forEach(function (m) { (byYear[m.year] = byYear[m.year] || []).push(m); });
    var years = Object.keys(byYear).map(Number).sort(function (a, b) { return b - a; });
    var groupsHtml = years.map(function (y) {
      var inner = byYear[y].map(function (m) {
        return '<div class="fxti-model" data-fxti-model="' + esc(m.id) + '"><span class="fxti-model__name">' + esc(m.model) + '</span></div>';
      }).join('');
      return '<div class="fxti-models-group"><div class="fxti-year-header">' + y + '</div>' + inner + '</div>';
    }).join('');
    return '<p class="fxti-step__legend">Modelo</p>' +
      '<h2 class="fxti-step__title">Elige tu iPhone</h2>' +
      '<p class="fxti-step__sub">Selecciona el que vas a entregar. Si no lo ves, escribe el nombre.</p>' +
      '<div class="fxti-search"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg><input type="text" placeholder="iPhone 13, iPhone 14 Pro…" data-fxti-search></div>' +
      '<div class="fxti-models" data-fxti-models>' + groupsHtml + '</div>';
  }

  function renderQuestionStep(qKey) {
    var q = RULES.questions[qKey];
    if (!q) return '<p>Pregunta no encontrada</p>';
    var sel = state.answers[qKey];
    var opts = q.options.map(function (o) {
      var active = (sel === o.key) ? ' is-active' : '';
      return '<div class="fxti-opt' + active + '" data-fxti-q="' + esc(qKey) + '" data-fxti-a="' + esc(o.key) + '" tabindex="0" role="button"><span class="fxti-opt__r"></span><span class="fxti-opt__tx">' + esc(o.label) + '</span></div>';
    }).join('');
    return '<p class="fxti-step__legend">Estado</p>' +
      '<h2 class="fxti-step__title">' + esc(q.label) + '</h2>' +
      '<div class="fxti-options">' + opts + '</div>';
  }

  function renderBatteryStep() {
    if (!state.modelMeta) return '<p class="fxti-step__sub">Selecciona primero un modelo.</p>';
    var profile = RULES.profiles[state.modelMeta.rules_profile] || RULES.profiles.iphone_older;
    var sel = state.battery;
    var opts = profile.battery_steps.map(function (b) {
      var a = (sel === b.key) ? ' is-active' : '';
      return '<div class="fxti-opt' + a + '" data-fxti-battery="' + esc(b.key) + '" tabindex="0" role="button"><span class="fxti-opt__r"></span><span class="fxti-opt__tx">' + esc(b.label) + '</span></div>';
    }).join('');
    return '<p class="fxti-step__legend">Batería</p>' +
      '<h2 class="fxti-step__title">¿Qué salud de batería tiene?</h2>' +
      '<p class="fxti-step__sub">Ajustes → Batería → Estado de la batería</p>' +
      '<div class="fxti-options">' + opts + '</div>';
  }

  function renderImeiStep() {
    return '<p class="fxti-step__legend">Verificación</p>' +
      '<h2 class="fxti-step__title">IMEI o número de serie</h2>' +
      '<p class="fxti-step__sub">Es recomendado para confirmar el modelo exacto antes de la valoración definitiva. Puedes encontrarlo marcando <strong>*#06#</strong> en el teléfono o en Ajustes → General → Información.</p>' +
      '<div class="fxti-field"><label for="fxti-imei">IMEI / Serial <small class="fxti-field__hint" style="font-weight:400;color:var(--fxti-hint)">(opcional)</small></label>' +
      '<input id="fxti-imei" type="text" inputmode="numeric" autocomplete="off" maxlength="22" value="' + esc(state.imei || '') + '" data-fxti-imei placeholder="356789012345678"></div>' +
      '<p class="fxti-field__hint">Tus datos se tratan con confidencialidad y nunca se publican.</p>';
  }

  function renderCustomerStep() {
    var head = '<p class="fxti-step__legend">Tus datos</p>' +
      '<h2 class="fxti-step__title">Cómo te contactamos</h2>';
    if (state.mode === 'tasar') {
      return head + '<p class="fxti-step__sub">Te enviamos la valoración aproximada por email, sin compromiso.</p>' +
        field('name','Nombre','text', state.customer.name, true) +
        field('email','Email','email', state.customer.email, true);
    }
    return head + '<p class="fxti-step__sub">Necesitamos confirmarte la valoración definitiva tras la revisión.</p>' +
      field('name','Nombre','text', state.customer.name, true) +
      field('email','Email','email', state.customer.email, true) +
      field('phone','Teléfono','tel', state.customer.phone, true) +
      field('postal_code','Código postal','text', state.customer.postal_code, true);
  }
  function field(key, label, type, value, required) {
    return '<div class="fxti-field" data-fxti-field="' + key + '">' +
      '<label for="fxti-' + key + '">' + esc(label) + (required ? '<span class="req">*</span>' : '') + '</label>' +
      '<input id="fxti-' + key + '" type="' + type + '" value="' + esc(value || '') + '" data-fxti-customer="' + key + '" autocomplete="' + (key === 'name' ? 'name' : key === 'email' ? 'email' : key === 'phone' ? 'tel' : 'postal-code') + '">' +
      '<p class="fxti-field__err">Campo requerido</p></div>';
  }

  function renderMethodStep() {
    var s = state.method;
    return '<p class="fxti-step__legend">Entrega</p>' +
      '<h2 class="fxti-step__title">¿Cómo prefieres entregar el móvil?</h2>' +
      '<div class="fxti-options">' +
      '<div class="fxti-opt' + (s === 'store' ? ' is-active' : '') + '" data-fxti-method="store" tabindex="0" role="button"><span class="fxti-opt__r"></span><span class="fxti-opt__tx">En tienda Fixtore Gandía<small>Trae el móvil y lo revisamos en persona</small></span></div>' +
      '<div class="fxti-opt' + (s === 'ship' ? ' is-active' : '') + '" data-fxti-method="ship" tabindex="0" role="button"><span class="fxti-opt__r"></span><span class="fxti-opt__tx">Enviar a Fixtore<small>Te enviamos instrucciones por email</small></span></div>' +
      '</div>';
  }

  function renderLegalStep() {
    var needsShipping = (state.method === 'ship');
    var checks = '';
    checks += '<label class="fxti-check"><input type="checkbox" data-fxti-legal="provisional_valuation"' + (state.legal.provisional_valuation ? ' checked' : '') + '><span class="fxti-check__tx">He leído y acepto que la valoración mostrada es aproximada y que el valor definitivo se confirmará únicamente después de la revisión técnica de Fixtore.</span></label>';
    if (needsShipping) {
      checks += '<label class="fxti-check"><input type="checkbox" data-fxti-legal="return_shipping_cost"' + (state.legal.return_shipping_cost ? ' checked' : '') + '><span class="fxti-check__tx">Entiendo que si envío mi dispositivo a Fixtore y rechazo la valoración final, los gastos de devolución correrán a mi cargo.</span></label>';
    }
    checks += '<label class="fxti-check"><input type="checkbox" data-fxti-legal="privacy"' + (state.legal.privacy ? ' checked' : '') + '><span class="fxti-check__tx">Acepto la <a href="/policies/privacy-policy" target="_blank" rel="noopener">política de privacidad</a>. Usaremos estos datos exclusivamente para gestionar tu solicitud de Plan Renove.</span></label>';
    return '<p class="fxti-step__legend">Casi listo</p>' +
      '<h2 class="fxti-step__title">Confirmación</h2>' +
      '<p class="fxti-step__sub">Revisa y acepta las condiciones antes de enviar la solicitud.</p>' +
      checks;
  }

  function renderResultStep() {
    var r = state.result || compute();
    state.result = r;
    if (!state.quoteId) state.quoteId = makeQuoteId();
    var html = '<div class="fxti-result">';
    html += '<p class="fxti-result__sub">Valoración aproximada de tu</p>';
    html += '<p class="fxti-result__model">' + esc((state.modelMeta && state.modelMeta.model) || '\u2014') + ' ' + esc(state.capacity || '') + '</p>';
    if (r.blocked) {
      html += '<div class="fxti-result__blocked"><strong>No podemos aceptar el dispositivo todavía.</strong><br>Para aceptarlo, debe entregarse con iCloud y Buscar mi iPhone desactivados.</div>';
    } else if (r.manualReview) {
      html += '<div class="fxti-result__manual"><strong>Revisión manual necesaria.</strong><br>No podemos darte una estimación automática fiable. Nuestro equipo técnico revisará tu dispositivo manualmente y te confirmará la valoración.</div>';
    } else {
      html += '<p class="fxti-result__amount"><span>Hasta</span>' + r.value + ' €</p>';
      html += '<p class="fxti-result__grade">' + esc(r.gradeLabel) + '</p>';
      if (state.mode === 'renew' && state.refundChoice === 'credit') {
        var credit = Math.round(r.value * 1.1 / 5) * 5;
        html += '<p class="fxti-result__pending">🎁 En saldo Fixtore: hasta ' + credit + ' € (+10%)</p>';
      } else {
        html += '<p class="fxti-result__pending">⏱ Pendiente de tasación final tras la revisión</p>';
      }
    }
    if (state.mode === 'tasar') {
      html += '<div class="fxti-result__disclaim">Esta estimación es orientativa. Para renovar: compra tu nuevo iPhone en Fixtore y vuelve aquí con tu número de pedido. Tras enviar tu móvil y revisarlo (máx. 72 h), te confirmamos el valor final y te lo reintegramos.</div>';
      html += '<a class="fxti-btn fxti-btn--primary" style="display:inline-flex;margin-top:4px" href="/collections/iphone" data-fxti-buy>Ver iPhones en Fixtore</a>';
    } else {
      html += '<div class="fxti-result__disclaim">Esta estimación es orientativa y puede variar. Al solicitar la recogida, envías tu móvil; en un máximo de 72 h hacemos la tasación final y te la comunicamos. Si la aceptas, recibes el reintegro' + (state.refundChoice === 'credit' ? ' en saldo Fixtore con +10%' : ' sobre tu pedido') + '. Si no la aceptas, te devolvemos el móvil asumiendo tú los gastos de envío de vuelta.</div>';
    }
    html += '<p class="fxti-quote-id">ID de solicitud · ' + esc(state.quoteId) + '</p>';
    html += '</div>';
    return html;
  }

  function renderFooter(idx) {
    var foot = modalEl.querySelector('[data-fxti-foot]');
    if (!foot) return;
    var step = STEPS[idx];
    var isLast = (step.id === 'result');
    var isFirst = (idx === 0);
    if (step.id === 'mode') {
      foot.innerHTML = '<button type="button" class="fxti-btn fxti-btn--ghost" data-fxti-close>Cancelar</button><span class="fxti-step-counter" data-fxti-counter></span>';
      foot.querySelector('[data-fxti-close]').addEventListener('click', closeModal);
      return;
    }
    if (isLast) {
      var submitTxt = (state.mode === 'tasar') ? 'Recibir mi tasación' : 'Solicitar recogida';
      foot.innerHTML =
        '<button type="button" class="fxti-btn fxti-btn--ghost" data-fxti-close>Cerrar</button>' +
        ((state.result && (state.result.blocked)) ? '' : '<button type="button" class="fxti-btn fxti-btn--primary" data-fxti-submit>' + submitTxt + '</button>');
      foot.querySelector('[data-fxti-close]').addEventListener('click', closeModal);
      var sb = foot.querySelector('[data-fxti-submit]');
      if (sb) sb.addEventListener('click', submit);
    } else {
      foot.innerHTML =
        (isFirst ? '<button type="button" class="fxti-btn fxti-btn--ghost" data-fxti-close>Cancelar</button>' : '<button type="button" class="fxti-btn fxti-btn--ghost" data-fxti-prev>Atrás</button>') +
        '<span class="fxti-step-counter" data-fxti-counter></span>' +
        '<button type="button" class="fxti-btn fxti-btn--primary" data-fxti-next>Continuar</button>';
      var prev = foot.querySelector('[data-fxti-prev]');
      var nxt = foot.querySelector('[data-fxti-next]');
      var c = foot.querySelector('[data-fxti-close]');
      if (prev) prev.addEventListener('click', function () { renderStep(Math.max(0, idx - 1)); });
      if (c) c.addEventListener('click', closeModal);
      if (nxt) nxt.addEventListener('click', function () {
        if (validateStep(idx)) renderStep(Math.min(STEPS.length - 1, idx + 1));
      });
      var counterEl = foot.querySelector('[data-fxti-counter]');
      if (counterEl) counterEl.textContent = 'Paso ' + (idx + 1) + ' de ' + STEPS.length;
    }
  }

  function autoNext(){
    setTimeout(function(){
      if (validateStep(state.step)) renderStep(Math.min(STEPS.length - 1, state.step + 1));
    }, 260);
  }
  function wireStep(step) {
    var body = modalEl.querySelector('[data-fxti-body]');
    if (step.id === 'mode') {
      body.querySelectorAll('[data-fxti-mode]').forEach(function (el) {
        el.addEventListener('click', function () {
          state.mode = el.getAttribute('data-fxti-mode');
          buildSteps();
          renderStep(1);
        });
      });
    }
    if (step.id === 'order') {
      var oi = body.querySelector('[data-fxti-order]');
      if (oi) oi.addEventListener('input', function () { state.orderNumber = oi.value; });
    }
    if (step.id === 'refund') {
      body.querySelectorAll('[data-fxti-refund]').forEach(function (el) {
        el.addEventListener('click', function () {
          state.refundChoice = el.getAttribute('data-fxti-refund');
          body.querySelectorAll('[data-fxti-refund]').forEach(function(o){o.classList.remove('is-active');});
          el.classList.add('is-active');
          autoNext();
        });
      });
    }
    if (step.id === 'model') {
      body.querySelectorAll('[data-fxti-model]').forEach(function (el) {
        el.addEventListener('click', function () {
          var id = el.getAttribute('data-fxti-model');
          var m = findModel(id);
          state.modelId = id;
          state.modelMeta = m;
          state.capacity = null;
          renderStep(state.step);
          setTimeout(function () {
            var c = modalEl.querySelector('.fxti-caps-grid');
            if (c) c.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }, 80);
        });
      });
      var changeBtn = body.querySelector('[data-fxti-change-model]');
      if (changeBtn) changeBtn.addEventListener('click', function () {
        state.modelId = null; state.modelMeta = null; state.capacity = null;
        renderStep(state.step);
      });
      body.querySelectorAll('[data-fxti-cap]').forEach(function (el) {
        el.addEventListener('click', function () {
          state.capacity = el.getAttribute('data-fxti-cap');
          body.querySelectorAll('[data-fxti-cap]').forEach(function(b){b.classList.remove('is-active');});
          el.classList.add('is-active');
          autoNext();
        });
      });
      var srch = body.querySelector('[data-fxti-search]');
      if (srch) srch.addEventListener('input', function () {
        var q = srch.value.toLowerCase().trim();
        var visible = 0;
        body.querySelectorAll('[data-fxti-model]').forEach(function (el) {
          var name = el.querySelector('.fxti-model__name').textContent.toLowerCase();
          var match = (q === '') ? true : name.indexOf(q) >= 0;
          el.style.display = match ? '' : 'none';
          if (match) visible++;
        });
        var groups = body.querySelectorAll('.fxti-models-group');
        groups.forEach(function (g) {
          var anyVisible = false;
          g.querySelectorAll('[data-fxti-model]').forEach(function (el) {
            if (el.style.display !== 'none') anyVisible = true;
          });
          g.querySelector('.fxti-year-header').style.display = anyVisible ? '' : 'none';
        });
        var fbEl = body.querySelector('[data-fxti-fallback]');
        if (visible === 0 && q.length > 1) {
          if (!fbEl) {
            var html = '<div class="fxti-fallback-card" data-fxti-fallback>' +
              '<div class="fxti-fallback-card__icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg></div>' +
              '<div class="fxti-fallback-card__tx"><strong>No encontramos ese modelo</strong><small>Solicita revisión manual y nuestro equipo lo valorará</small></div>' +
              '<button type="button" class="fxti-btn fxti-btn--ghost" data-fxti-fallback-go>Solicitar</button>' +
              '</div>';
            body.querySelector('[data-fxti-models]').insertAdjacentHTML('afterbegin', html);
            var goBtn = body.querySelector('[data-fxti-fallback-go]');
            goBtn.addEventListener('click', function () {
              var typed = srch.value.trim();
              state.modelId = 'other-manual';
              state.modelMeta = {
                brand: 'Apple', model: typed || 'Modelo no listado', year: '',
                rules_profile: 'manual_review',
                capacities: { 'Pendiente revisión': { max_value: 0, base_value: 0, min_value: 0 } }
              };
              state.capacity = 'Pendiente revisión';
              renderStep(state.step);
            });
          }
        } else if (fbEl) {
          fbEl.remove();
        }
      });
    }
    if (step.question) {
      body.querySelectorAll('[data-fxti-q]').forEach(function (el) {
        el.addEventListener('click', function () {
          var k = el.getAttribute('data-fxti-q'), a = el.getAttribute('data-fxti-a');
          state.answers[k] = a;
          body.querySelectorAll('[data-fxti-q]').forEach(function(o){o.classList.remove('is-active');});
          el.classList.add('is-active');
          autoNext();
        });
      });
    }
    if (step.id === 'battery') {
      body.querySelectorAll('[data-fxti-battery]').forEach(function (el) {
        el.addEventListener('click', function () {
          state.battery = el.getAttribute('data-fxti-battery');
          body.querySelectorAll('[data-fxti-battery]').forEach(function(o){o.classList.remove('is-active');});
          el.classList.add('is-active');
          autoNext();
        });
      });
    }
    if (step.id === 'method') {
      body.querySelectorAll('[data-fxti-method]').forEach(function (el) {
        el.addEventListener('click', function () {
          state.method = el.getAttribute('data-fxti-method');
          body.querySelectorAll('[data-fxti-method]').forEach(function(o){o.classList.remove('is-active');});
          el.classList.add('is-active');
          autoNext();
        });
      });
    }
    if (step.id === 'imei') {
      var inp = body.querySelector('[data-fxti-imei]');
      if (inp) inp.addEventListener('input', function () { state.imei = inp.value.replace(/[^0-9A-Za-z]/g,''); });
    }
    if (step.id === 'customer') {
      body.querySelectorAll('[data-fxti-customer]').forEach(function (inp) {
        var k = inp.getAttribute('data-fxti-customer');
        inp.addEventListener('input', function () { state.customer[k] = inp.value; });
      });
    }
    if (step.id === 'legal') {
      body.querySelectorAll('[data-fxti-legal]').forEach(function (inp) {
        var k = inp.getAttribute('data-fxti-legal');
        inp.addEventListener('change', function () { state.legal[k] = inp.checked; });
      });
    }
  }

  function findModel(id) {
    var brand = DEVICES.brands[0];
    for (var i = 0; i < brand.models.length; i++) if (brand.models[i].id === id) return brand.models[i];
    return null;
  }

  function validateStep(idx) {
    var step = STEPS[idx];
    if (!step) return true;
    if (step.id === 'model') {
      if (!state.modelId || !state.capacity) { alert('Selecciona modelo y capacidad para continuar'); return false; }
      return true;
    }
    if (step.question) {
      if (!state.answers[step.question]) { alert('Selecciona una opción para continuar'); return false; }
      return true;
    }
    if (step.id === 'battery') {
      if (!state.battery) { alert('Selecciona la salud de batería para continuar'); return false; }
      return true;
    }
    if (step.id === 'order') {
      var fo = modalEl.querySelector('[data-fxti-field="order"]');
      var ov = (state.orderNumber || '').replace(/[^0-9]/g,'');
      var okO = ov.length >= 3;
      if (fo) fo.classList.toggle('is-error', !okO);
      if (!okO) return false;
      return true;
    }
    if (step.id === 'refund') {
      if (!state.refundChoice) { alert('Elige cómo quieres el reintegro'); return false; }
      return true;
    }
    if (step.id === 'customer') {
      var ok = true;
      var fields = (state.mode === 'tasar') ? ['name','email'] : ['name','email','phone','postal_code'];
      fields.forEach(function (k) {
        var f = modalEl.querySelector('[data-fxti-field="' + k + '"]');
        var v = (state.customer[k] || '').trim();
        var valid = v.length > 0;
        if (k === 'email') valid = valid && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
        if (k === 'phone') valid = valid && v.replace(/\D/g,'').length >= 9;
        if (k === 'postal_code') valid = valid && /^[0-9]{5}$/.test(v);
        if (f) f.classList.toggle('is-error', !valid);
        if (!valid) ok = false;
      });
      return ok;
    }
    if (step.id === 'method') {
      if (!state.method) { alert('Selecciona un método de entrega'); return false; }
      return true;
    }
    if (step.id === 'legal') {
      if (!state.legal.provisional_valuation) { alert('Debes aceptar la valoración provisional'); return false; }
      if (!state.legal.privacy) { alert('Debes aceptar la política de privacidad'); return false; }
      if (state.method === 'ship' && !state.legal.return_shipping_cost) { alert('Debes aceptar los gastos de devolución para enviar'); return false; }
      return true;
    }
    return true;
  }

  // ----- MOTOR DE TASACIÓN -----
  function compute() {
    var flags = [];
    var blocked = false;
    var manualReview = false;
    if (!state.modelMeta || !state.capacity) return { value: 0, gradeLabel: '—', flags: ['no_model'], manualReview: true };
    var cap = state.modelMeta.capacities[state.capacity];
    if (!cap) return { value: 0, gradeLabel: '—', flags: ['no_capacity'], manualReview: true };

    var base = cap.base_value;
    var max = cap.max_value;
    var min = cap.min_value;
    var totalPenaltyPct = 0;
    var capPct = null;

    // Recoger respuestas
    Object.keys(state.answers).forEach(function (qk) {
      var ak = state.answers[qk];
      var q = RULES.questions[qk]; if (!q) return;
      var opt = q.options.filter(function (o) { return o.key === ak; })[0];
      if (!opt) return;
      totalPenaltyPct += (opt.modifier_pct || 0);
      if (opt.flag) flags.push(opt.flag);
      if (opt.cap_pct != null) capPct = (capPct == null) ? opt.cap_pct : Math.min(capPct, opt.cap_pct);
    });

    // Batería (perfil específico)
    var profile = RULES.profiles[state.modelMeta.rules_profile] || RULES.profiles.iphone_older;
    var batStep = (profile.battery_steps || []).filter(function (b) { return b.key === state.battery; })[0];
    if (batStep) totalPenaltyPct += (batStep.modifier_pct || 0);
    // Forzar revisión manual si profile lo indica
    if (state.modelMeta.rules_profile === 'manual_review') {
      return { value: 0, grade: 'Sin grado', gradeLabel: 'Revisión manual', flags: ['manual_review'], blocked: false, manualReview: true, confidence: 'lower', base: 0, max: 0, min: 0 };
    }

    // Margen seguridad
    totalPenaltyPct -= (RULES.global.safety_margin_pct || 0);

    // Cap si fallo grave
    var value;
    if (capPct != null) {
      value = base * (capPct / 100);
    } else {
      value = base * (1 + totalPenaltyPct / 100);
    }
    value = Math.max(0, Math.min(max, Math.round(value)));
    // Redondeo
    var rt = RULES.global.round_to || 5;
    value = Math.round(value / rt) * rt;

    // Flags / bloqueos
    var blockingFlags = RULES.blocking_flags || [];
    var manualFlags = RULES.manual_review_flags || [];
    flags.forEach(function (f) {
      if (blockingFlags.indexOf(f) >= 0) blocked = true;
      if (manualFlags.indexOf(f) >= 0) manualReview = true;
    });
    if (value < (RULES.global.min_valuation_threshold || 0)) {
      manualReview = true;
    }
    if (value < min) {
      manualReview = true;
    }

    var gradeLabel = pickGradeLabel(base, value);
    var confidence = state.imei ? 'medium' : 'lower';

    return {
      value: value,
      grade: gradeLabel,
      gradeLabel: gradeLabel,
      flags: flags,
      blocked: blocked,
      manualReview: manualReview,
      confidence: confidence,
      base: base,
      max: max,
      min: min
    };
  }

  function pickGradeLabel(base, value) {
    var pct = (value / base) * 100;
    var grades = RULES.grades || [];
    for (var i = 0; i < grades.length; i++) {
      if (pct >= grades[i].min_pct_of_base) return grades[i].label;
    }
    return grades.length ? grades[grades.length - 1].label : 'Sin grado';
  }

  function makeQuoteId() {
    var d = new Date();
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var dat = '' + d.getFullYear() + pad(d.getMonth()+1) + pad(d.getDate());
    var tim = '' + pad(d.getHours()) + pad(d.getMinutes()) + pad(d.getSeconds());
    var rnd = Math.random().toString(36).slice(2, 6).toUpperCase();
    return 'FXTR-TI-' + dat + '-' + tim + '-' + rnd;
  }

  // ----- ENVÍO -----
  function buildPayload() {
    var r = state.result || compute();
    return {
      quote_id: state.quoteId,
      created_at: new Date().toISOString(),
      source: 'product_page',
      origin_product: state.originProduct || null,
      customer: state.customer,
      device: {
        brand: state.modelMeta ? state.modelMeta.brand || 'Apple' : 'Apple',
        model: state.modelMeta ? state.modelMeta.model : null,
        model_id: state.modelId,
        capacity: state.capacity,
        imei_status: state.imei ? 'provided' : 'not_provided',
        // IMEI solo se envía al webhook si está configurado, NUNCA al cart attributes
        imei: state.imei || null,
        declared_battery: state.battery,
        declared_answers: state.answers
      },
      valuation: {
        estimated_value: r.value,
        grade: r.grade,
        status: r.blocked ? 'blocked_icloud' : (r.manualReview ? 'manual_review' : 'pending_review'),
        confidence: r.confidence,
        flags: r.flags || []
      },
      method: state.method,
      mode: state.mode,
      order_number: state.orderNumber || null,
      refund_choice: state.refundChoice || null,
      legal_acceptance: state.legal
    };
  }

  function updateCartAttributes() {
    var r = state.result || {};
    // Atributos informativos al carrito (SIN IMEI, SIN datos sensibles)
    var attrs = {
      'trade_in_quote_id': state.quoteId || '',
      'trade_in_origin_product_id': state.originProduct ? String(state.originProduct.id || '') : '',
      'trade_in_origin_product_title': state.originProduct ? state.originProduct.title || '' : '',
      'trade_in_origin_variant_id': state.originProduct ? String(state.originProduct.variant_id || '') : '',
      'trade_in_customer_device_brand': state.modelMeta ? (state.modelMeta.brand || 'Apple') : 'Apple',
      'trade_in_customer_device_model': state.modelMeta ? state.modelMeta.model : '',
      'trade_in_customer_device_capacity': state.capacity || '',
      'trade_in_estimated_value': r.value || 0,
      'trade_in_grade': r.grade || '',
      'trade_in_status': 'pending_review',
      'trade_in_channel': 'product_page',
      'trade_in_review_required': true
    };
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function (e) { log('cart attrs failed', e); });
  }

  function submit() {
    var payload = buildPayload();
    log('submit payload', payload);

    var promises = [];
    promises.push(updateCartAttributes());

    if (CONFIG.enableWebhook && CONFIG.webhookUrl) {
      promises.push(
        fetch(CONFIG.webhookUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
          mode: 'cors'
        }).catch(function (e) { log('webhook failed', e); })
      );
    }

    var btn = modalEl.querySelector('[data-fxti-submit]');
    if (btn) { btn.disabled = true; btn.textContent = 'Enviando…'; }

    Promise.all(promises).then(function () {
      showThanks();
    });
  }

  function showThanks() {
    var body = modalEl.querySelector('[data-fxti-body]');
    body.innerHTML = '<div class="fxti-step is-on" style="text-align:center;padding:24px 8px"><svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#00A86B" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" style="margin:0 auto 12px;display:block"><circle cx="12" cy="12" r="10"/><polyline points="9 12 11.5 14.5 16 9.5"/></svg>' +
      '<h2 class="fxti-step__title">Solicitud enviada</h2>' +
      '<p class="fxti-step__sub">Te contactaremos por email para confirmar los siguientes pasos.</p>' +
      (state.method === 'ship' ? '<p class="fxti-step__sub" style="background:#F4F0E4;border-radius:6px;padding:12px;color:#1F1F1F">Recibirás un email con las instrucciones de envío. Cuando recibamos el móvil, lo revisaremos y te confirmaremos la valoración definitiva.</p>' : '<p class="fxti-step__sub" style="background:#F4F0E4;border-radius:6px;padding:12px;color:#1F1F1F">Puedes traer tu móvil a Fixtore Gandía cuando quieras. Atendemos en horario de tienda.</p>') +
      '<p class="fxti-quote-id">ID de solicitud · ' + esc(state.quoteId) + '</p></div>';
    var foot = modalEl.querySelector('[data-fxti-foot]');
    foot.innerHTML = '<button type="button" class="fxti-btn fxti-btn--primary" data-fxti-close>Cerrar</button>';
    foot.querySelector('[data-fxti-close]').addEventListener('click', closeModal);
    var pr = modalEl.querySelector('[data-fxti-progress]'); if (pr) pr.style.width = '100%';
  }

  // ----- INIT -----
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Exponer para debugging
  window.FXTI = { state: function(){ return state; }, compute: compute, open: openModal, close: closeModal };
})();
